import { render } from "./AddProductsPrice.vue?vue&type=template&id=62210a8f&scoped=true"
import script from "./AddProductsPrice.vue?vue&type=script&lang=js"
export * from "./AddProductsPrice.vue?vue&type=script&lang=js"

import "./AddProductsPrice.vue?vue&type=style&index=0&id=62210a8f&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62210a8f"]])

export default __exports__